import {Injectable} from '@angular/core';
import {packageJson} from '../../../../package-json';
import {ENVIRONMENT} from '../../../../environments/environment';

@Injectable()
export class StateService {

  constructor() {
  }

  public get appVersion(): string {
    return `${packageJson.version}.${ENVIRONMENT.commitHash}`;
  }

}
